import React, { useEffect, useMemo, useState } from "react"
import {
  computeKyotoOpeningDisplay,
  getKyotoSimulatedNow,
} from "../utils/kyotoOpeningHours"

const HeaderOpeningHours = () => {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60_000)
    return () => clearInterval(id)
  }, [])

  const { isOpen, title, subtitle } = useMemo(
    () => computeKyotoOpeningDisplay(getKyotoSimulatedNow()),
    [tick]
  )

  return (
    <div
      className="hidden md:flex flex-col items-end text-right leading-tight max-w-[13rem] shrink min-w-0 mr-2"
      aria-live="polite"
    >
      <span className="text-[10px] uppercase tracking-wide text-black/60">
        Öffnungszeiten
      </span>
      <span className="flex items-center justify-end gap-1.5 mt-0.5">
        <span
          className={`w-1.5 h-1.5 rounded-full shrink-0 mt-0.5 ${
            isOpen
              ? "bg-green-600 animate-opening-status-pulse"
              : "bg-neutral-400"
          }`}
          aria-hidden
        />
        <span className="text-xs font-medium text-black text-right">
          {title}
        </span>
      </span>
      {subtitle ? (
        <span className="text-[11px] text-black/85 mt-0.5">{subtitle}</span>
      ) : null}
    </div>
  )
}

export default HeaderOpeningHours
